import React, { useState, useContext, Fragment } from "react";
import { DragAndDropContext } from "../../../context/DragAndDropContext";
import "./Column.scss";
import NestedColumn from "./NestedColumn/NestedColumn";
import NestedAccordion from "../Accordion/NestedAccordion/NestedAccordion";
import Draggable from "../../../containers/Draggable/Draggable";
import ColumnBG from "./ColumnSettings/ColumnSettings";
import BUTTON from "../Button/Button";
import Image from "../Image/Image";
import LayoutIcon from "../../../assets/images/LayoutIcon.svg";
import Form from "../Form/Form";
import TABLEEditor from "../TABLE/Table";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import cloneDeep from "lodash.clonedeep";
import TimerElement from "../Timer/Timer";
import Text from "../Text/Text";
import Line from "../Line/Line";
import File from "../File/File";
import VideoElement from "../Video/Video";
import RowSetting from "./ColumnSettings/RowSetting";
import ErrorBoundary from "../../../utils/ErrorBoundary";
import AddToolButton from "../../Tool/AddToolButton/AddToolButton";
import LayoutChangeModal from "./ColumnSettings/LayoutChangeModal";
import * as UTILS from "../../../utils/Utils";
import HTMLEditor from "../HTML/Html";

const RowColumns = (props) => {
  const [state, setState] = useState({
    id: null,
    layoutChangeColmId: null,
    resizeID: null,
    image: "your-image-url or as base64",
    crop: { x: 0, y: 0 },
    zoom: 1,
    aspect: 4 / 3,
    editID: null,
    noContent: false,
    columns: props.columns,
    enableModuleBgChange: false,
    enableContentModal: false,
    element: props.element,
  });

  const {
    onDragEnter,
    onDragOver,
    onDrag,
    onDragEnd,
    barLocation,
    dragOverElement,
    dragOverColumnIndex,
    dragOverParent,
  } = useContext(DragAndDropContext);
  const getMinSize = (dropContainerWidth) => {
    let value = dropContainerWidth
      ? (dropContainerWidth -
          (props.gutterSpaceBtwnCol ? Number(props.gutterSpaceBtwnCol) : 0) -
          (props.gridGuideColumns ? Number(props.gridGuideColumns) - 1 : 11) *
            (props.gutterSpaceBtwnCol ? Number(props.gutterSpaceBtwnCol) : 0)) /
        (props.gridGuideColumns ? Number(props.gridGuideColumns) : 12)
      : 0;
    return value;
  };
  const getSizes = (sizes, id) => {
    const layout = props.layout;
    const newList = cloneDeep(layout);
    newList.map((item, index) => {
      if (item.id == id) {
        item.deskWidth = sizes;
        return item;
      }
      if (item.id !== id && item.columns) {
        Object.keys(item.columns).map((col, colIndex) => {
          item.columns[col].map((colItem, colItemIndex) => {
            if (colItem.id == id) {
              colItem.deskWidth = sizes;
              return colItem;
            }
          });
        });
      }
    });
    // props.getList(newList);
    props.layoutArray(props.layoutTitle, newList);
  };
  const setIdForEditHandler = (editID) => {
    setState(
      {
        id: editID,
      }

    );
  };
  const setIdForLayoutChange = (ID) => {
    setState(
      {
        layoutChangeColmId: ID,
      }
    );
  };

  const dropContainerWidth =
    document.getElementsByClassName("dropContainer")[0] &&
    document.getElementsByClassName("dropContainer")[0].offsetWidth;
  return (
    <Fragment key={props.index}>
      {!props.element.dataModule && (
        <div className="rowActionControl">
          <button
            onClick={() => setIdForEditHandler(props.ID)}
            title="Settings"
            className="setting-column"
          >
            <small>Setting</small>
          </button>
          <button
            onClick={() => props.cloneElement(props.ID)}
            className="clone-item"
          >
            <img title="Clone" src={props.CloneICON} />
            <small>Clone</small>
          </button>
          {/* <span
              className={
                "resizeColumIcon " + (props.resizeID === props.ID ? " active" : " ")
              }
              onClick={props.resizeColumn}
            >
              <img src={ResizeIcon} />
              <small>Resize column</small>
            </span> */}
          {props.deskWidth && (
            <span
              className="layoutColumIcon"
              onClick={(e) => setIdForLayoutChange(props.ID)}
            >
              <img title="Change Layout" src={LayoutIcon} />
              <small>Change Layout</small>
            </span>
          )}

          <Fragment>
            <div className="addRemoveWrapper">
              {props.deskWidth.length <= 5 && (
                <span
                  onClick={(e) => {
                    let dataModule = props.element.dataModule ? true : false;
                    props.addRemoveColumn(e, props.ID, "add", dataModule);
                  }}
                  title="Add Column"
                  className="addColumn"
                >
                  +<small>Add Column</small>
                </span>
              )}
              {props.deskWidth.length > 1 && (
                <span
                  onClick={(e) => {
                    props.addRemoveColumn(e, props.ID, "remove");
                  }}
                  title="Remove Column"
                  className="removeColumn"
                >
                  -<small>Remove Column</small>
                </span>
              )}
            </div>
          </Fragment>

          <span
            className="delete-item"
            onClick={() => props.deleteElement(props.ID)}
          >
            <i className="far fa-trash-alt" />
            <small>Delete</small>
          </span>
        </div>
      )}

      <div
        className="row-container"
        id={props.ID}
        style={{ width: "100%", height: "100%", position: "relative" }}
      >
        <div
          style={
            props.rowStyle
              ? {
                  backgroundImage:
                    (props.rowBg !== null || props.rowBg !== "") &&
                    (props.rowCroppedBg == "" || props.rowCroppedBg == null)
                      ? "url('" + props.rowBg + "')"
                      : "url('" + props.rowCroppedBg + "')",
                  backgroundColor:
                    typeof props.rowBgColor == "string"
                      ? props.rowBgColor
                      : `rgba(
                    ${props.rowBgColor.r},
                    ${props.rowBgColor.g},
                    ${props.rowBgColor.b},
                    ${props.rowBgColor.a}
                  )`,
                  backgroundRepeat: props.bgRepeat,
                  opacity: props.rowOpacity ? props.rowOpacity : "1.0",
                  backgroundSize: props.bgSize,
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  left: "0",
                  top: "0",
                }
              : {
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  left: "0",
                  top: "0",
                }
          }
        />
        {props.ID === state.id && (
          <RowSetting
            initP={props.initP}
            srcID={props.srcID}
            userID={props.userID}
            sessionID={props.sessionID}
            rowBg={props.rowBg}
            rowOpacity={props.rowOpacity}
            rowBgColor={props.rowBgColor}
            bgRepeat={props.bgRepeat}
            label={props.label}
            bgSize={props.bgSize}
            rowCroppedBg={props.rowCroppedBg}
            rowBorderColor={props.rowBorderColor}
            rowStyle={props.rowStyle}
            borderWidth={props.borderWidth}
            ID={props.ID}
            name={props.element.name}
            gutterSpaceBtwnCol={props.gutterSpaceBtwnCol}
            gutterSpaceBtwnColMobile={props.gutterSpaceBtwnColMobile}
            setIdForEditHandler={setIdForEditHandler}
          />
        )}
        {props.ID === state.layoutChangeColmId && (
          <LayoutChangeModal
            initP={props.initP}
            srcID={props.srcID}
            userID={props.userID}
            sessionID={props.sessionID}
            ID={props.ID}
            deskWidth={props.deskWidth}
            setIdForLayoutChange={setIdForLayoutChange}
            changeColmLayout={props.changeColmLayout}
          />
        )}
        <div
          style={{
            height: "100%",
            paddingRight:
              props.canvasRowsPadding &&
              props.enableWidthForRow !== "undefined" &&
              props.enableWidthForRow == true &&
              !props.mobileView
                ? props.canvasRowsPadding[1] +
                  (props.canvasRowsPaddingUnit
                    ? props.canvasRowsPaddingUnit
                    : "px")
                : "0",
            paddingLeft:
              props.canvasRowsPadding &&
              props.enableWidthForRow !== "undefined" &&
              props.enableWidthForRow == true &&
              !props.mobileView
                ? props.canvasRowsPadding[3] +
                  (props.canvasRowsPaddingUnit
                    ? props.canvasRowsPaddingUnit
                    : "px")
                : "0",
          }}
        >
          <div
            key={props.index}
            className={
              "rowGrid" +
              (props.resizeID === props.ID ? " resizeColumn" : "") +
              (props.element.dataModule ? " dataModule" : "") +
              (props.enableWidthForRow ? " rowWidthEnabled" : " ")
            }
            style={
              props.rowStyle
                ? {
                    height: "100%",
                    maxWidth: props.enableWidthForRow
                      ? props.containerWidth
                      : "unset",
                    margin: props.enableWidthForRow ? "0 auto" : "unset",
                    justifyContent: "center",
                    borderColor:
                      typeof props.rowBorderColor == "string" ||
                      !props.rowBorderColor
                        ? "rgba(252, 252, 252, 0)"
                        : `rgba(
              ${props.rowBorderColor.r},
              ${props.rowBorderColor.g},
              ${props.rowBorderColor.b},
              ${props.rowBorderColor.a}
            )`,
                    borderWidth: props.borderWidth + "px",
                    borderStyle: "solid",
                    justifyContent: "center",

                    paddingRight:
                      props.canvasRowsPadding &&
                      ((props.enableWidthForRow !== "undefined" &&
                        props.enableWidthForRow == false) ||
                        props.enableWidthForRow == undefined) &&
                      !props.mobileView
                        ? props.canvasRowsPadding[1] +
                          (props.canvasRowsPaddingUnit
                            ? props.canvasRowsPaddingUnit
                            : "px")
                        : props.canvasRowsPaddingMobile && props.mobileView
                        ? props.canvasRowsPaddingMobile
                          ? props.canvasRowsPaddingMobile[1] +
                            (props.canvasRowsPaddingUnit
                              ? props.canvasRowsPaddingUnit
                              : "px")
                          : "0"
                        : "0",
                    paddingLeft:
                      props.canvasRowsPadding &&
                      ((props.enableWidthForRow !== "undefined" &&
                        props.enableWidthForRow == false) ||
                        props.enableWidthForRow == undefined) &&
                      !props.mobileView
                        ? props.canvasRowsPadding[3] +
                          (props.canvasRowsPaddingUnit
                            ? props.canvasRowsPaddingUnit
                            : "px")
                        : props.canvasRowsPaddingMobile && props.mobileView
                        ? props.canvasRowsPaddingMobile
                          ? props.canvasRowsPaddingMobile[3] +
                            (props.canvasRowsPaddingUnit
                              ? props.canvasRowsPaddingUnit
                              : "px")
                          : "0"
                        : "0",
                    paddingTop:
                      props.rowStyle &&
                      props.rowStyle.paddingTop &&
                      !props.mobileView
                        ? props.rowStyle.paddingTop +
                          (props.rowStyle.paddingUnit
                            ? props.rowStyle.paddingUnit
                            : "px")
                        : props.rowStyle &&
                          props.rowStyle.paddingTopMobile &&
                          props.mobileView
                        ? props.rowStyle && props.rowStyle.paddingTopMobile
                          ? props.rowStyle.paddingTopMobile +
                            (props.rowStyle.paddingUnit
                              ? props.rowStyle.paddingUnit
                              : "px")
                          : "0"
                        : "0",
                    paddingBottom:
                      props.rowStyle &&
                      props.rowStyle.paddingBottom &&
                      !props.mobileView
                        ? props.rowStyle.paddingBottom +
                          (props.rowStyle.paddingUnit
                            ? props.rowStyle.paddingUnit
                            : "px")
                        : props.rowStyle &&
                          props.rowStyle.paddingBottomMobile &&
                          props.mobileView
                        ? props.rowStyle && props.rowStyle.paddingBottomMobile
                          ? props.rowStyle.paddingBottomMobile +
                            (props.rowStyle.paddingUnit
                              ? props.rowStyle.paddingUnit
                              : "px")
                          : "0"
                        : "0",
                  }
                : {
                    height: "100%",
                    maxWidth: props.enableWidthForRow
                      ? props.containerWidth
                      : "unset",
                    margin: props.enableWidthForRow ? "0 auto" : "unset",
                    justifyContent: "center",

                    //controlled by global styles
                    paddingRight:
                      props.canvasRowsPadding && !props.mobileView
                        ? props.canvasRowsPadding[1] +
                          (props.canvasRowsPaddingUnit
                            ? props.canvasRowsPaddingUnit
                            : "px")
                        : props.canvasRowsPaddingMobile && props.mobileView
                        ? props.canvasRowsPaddingMobile
                          ? props.canvasRowsPaddingMobile[1] +
                            (props.canvasRowsPaddingUnit
                              ? props.canvasRowsPaddingUnit
                              : "px")
                          : "0"
                        : "0",
                    paddingLeft:
                      props.canvasRowsPadding && !props.mobileView
                        ? props.canvasRowsPadding[3] +
                          (props.canvasRowsPaddingUnit
                            ? props.canvasRowsPaddingUnit
                            : "px")
                        : props.canvasRowsPaddingMobile && props.mobileView
                        ? props.canvasRowsPaddingMobile
                          ? props.canvasRowsPaddingMobile[3] +
                            (props.canvasRowsPaddingUnit
                              ? props.canvasRowsPaddingUnit
                              : "px")
                          : "0"
                        : "0",
                  }
            }
            id={props.ID == state.editID ? " activeResize" : " "}
            // onClick={(e) => {
            //   setState({
            //     editID: state.editID == null ? props.ID : null,
            //   });
            // }}
          >
            <Fragment>
              {Object.keys(props.columns).map((col, colKeyIndex) => {
                let isHideMobile = props.element.hideColumnOnMobile
                  ? props.element.hideColumnOnMobile.find((item, index) => {
                      return col == item;
                    }) == col
                    ? true
                    : false
                  : " ";

                return (
                  <div
                    onDragEnter={(e) => {
                      onDragEnter(e, null, null, props.element, colKeyIndex);
                    }}
                    key={colKeyIndex}
                    className={
                      "column" +
                      (props.columns[col].length == 0
                        ? " noContent"
                        : colKeyIndex == 0
                        ? " firstColumn"
                        : " ") +
                      (dragOverParent &&
                      (dragOverParent.id === props.element.id) &
                      (dragOverColumnIndex === colKeyIndex)
                        ? " draggedOver"
                        : "") 
                    }
                    id={isHideMobile == true ? "hideMobile" : " "}
                    style={{
                      width: `calc(
                          ${props.deskWidth && props.deskWidth[colKeyIndex] + "%"} 
                        - ${
                          (props.columnGap ||
                            (props.gutterSpaceBtwnCol &&
                              props.gutterSpaceBtwnCol !== "0")) &&
                          props.deskWidth &&
                          props.deskWidth.length > 1
                            ? Number(
                                props.columnGap ||
                                  (props.gutterSpaceBtwnCol &&
                                    props.gutterSpaceBtwnCol !== "0")
                              ) /
                        (props.deskWidth[colKeyIndex]
                                ? UTILS.columnGutterDivideValue[
                          UTILS.isFloat(props.deskWidth[colKeyIndex])
                            ? props.deskWidth[colKeyIndex].toFixed(2)
                            : props.deskWidth[colKeyIndex]
                                  ]
                                : 1)
                            : 0
                        }px)`,

                      paddingRight:
                        props.element.columnsBG && !props.mobileView
                          ? (props.element.columnsBG[col] &&
                            !props.element.columnsBG[col].gutterSpaceRight
                              ? props.element.columnsBG[col].gutterSpace
                                ? JSON.parse(
                                    props.element.columnsBG[col].gutterSpace
                                  )
                                : 15
                              : JSON.parse(
                                  props.element.columnsBG[col].gutterSpaceRight
                                )) +
                            (props.element.columnsBG[col].gutterSpaceUnit
                              ? props.element.columnsBG[col].gutterSpaceUnit
                              : "px")
                          : props.element.columnsBG && props.mobileView
                          ? (!props.element.columnsBG[col]
                              .gutterSpaceMobileRight
                              ? props.element.columnsBG[col].gutterSpaceMobile
                                ? JSON.parse(
                                    props.element.columnsBG[col]
                                      .gutterSpaceMobile
                                  )
                                : 0
                              : JSON.parse(
                                  props.element.columnsBG[col]
                                    .gutterSpaceMobileRight
                                )) +
                            (props.element.columnsBG[col].gutterSpaceUnit
                              ? props.element.columnsBG[col].gutterSpaceUnit
                              : "px")
                          : "0",

                      paddingLeft:
                        props.element.columnsBG && !props.mobileView
                          ? (!props.element.columnsBG[col].gutterSpaceLeft
                              ? props.element.columnsBG[col].gutterSpace
                                ? JSON.parse(
                                    props.element.columnsBG[col].gutterSpace
                                  )
                                : 15
                              : JSON.parse(
                                  props.element.columnsBG[col].gutterSpaceLeft
                                )) +
                            (props.element.columnsBG[col].gutterSpaceUnit
                              ? props.element.columnsBG[col].gutterSpaceUnit
                              : "px")
                          : props.element.columnsBG && props.mobileView
                          ? (!props.element.columnsBG[col].gutterSpaceMobileLeft
                              ? props.element.columnsBG[col].gutterSpaceMobile
                                ? JSON.parse(
                                    props.element.columnsBG[col]
                                      .gutterSpaceMobile
                                  )
                                : 0
                              : JSON.parse(
                                  props.element.columnsBG[col]
                                    .gutterSpaceMobileLeft
                                )) +
                            (props.element.columnsBG[col].gutterSpaceUnit
                              ? props.element.columnsBG[col].gutterSpaceUnit
                              : "px")
                          : "0",

                      paddingTop:
                        props.element.columnsBG && !props.mobileView
                          ? (!props.element.columnsBG[col]
                              .gutterSpaceTopBottom_T
                              ? props.element.columnsBG[col]
                                  .gutterSpaceTopBottom
                                ? JSON.parse(
                                    props.element.columnsBG[col]
                                      .gutterSpaceTopBottom
                                  )
                                : 0
                              : JSON.parse(
                                  props.element.columnsBG[col]
                                    .gutterSpaceTopBottom_T
                                )) +
                            (props.element.columnsBG[col].gutterSpaceUnit
                              ? props.element.columnsBG[col].gutterSpaceUnit
                              : "px")
                          : props.element.columnsBG && props.mobileView
                          ? (!props.element.columnsBG[col]
                              .gutterSpaceTopBottomMobileTop
                              ? props.element.columnsBG[col]
                                  .gutterSpaceTopBottomMobile
                                ? JSON.parse(
                                    props.element.columnsBG[col]
                                      .gutterSpaceTopBottomMobile
                                  )
                                : 0
                              : JSON.parse(
                                  props.element.columnsBG[col]
                                    .gutterSpaceTopBottomMobileTop
                                )) +
                            (props.element.columnsBG[col].gutterSpaceUnit
                              ? props.element.columnsBG[col].gutterSpaceUnit
                              : "px")
                          : "0",
                      paddingBottom:
                        props.element.columnsBG && !props.mobileView
                          ? (!props.element.columnsBG[col]
                              .gutterSpaceTopBottom_B
                              ? props.element.columnsBG[col]
                                  .gutterSpaceTopBottom
                                ? JSON.parse(
                                    props.element.columnsBG[col]
                                      .gutterSpaceTopBottom
                                  )
                                : 0
                              : JSON.parse(
                                  props.element.columnsBG[col]
                                    .gutterSpaceTopBottom_B
                                )) +
                            (props.element.columnsBG[col].gutterSpaceUnit
                              ? props.element.columnsBG[col].gutterSpaceUnit
                              : "px")
                          : props.element.columnsBG && props.mobileView
                          ? (!props.element.columnsBG[col]
                              .gutterSpaceTopBottomMobileBottom
                              ? props.element.columnsBG[col]
                                  .gutterSpaceTopBottomMobile
                                ? JSON.parse(
                                    props.element.columnsBG[col]
                                      .gutterSpaceTopBottomMobile
                                  )
                                : 0
                              : JSON.parse(
                                  props.element.columnsBG[col]
                                    .gutterSpaceTopBottomMobileBottom
                                )) +
                            (props.element.columnsBG[col].gutterSpaceUnit
                              ? props.element.columnsBG[col].gutterSpaceUnit
                              : "px")
                          : "0",
                      marginLeft:
                        props.columnGap && !props.mobileView
                          ? props.columnGap / 2 + "px"
                          : "",
                      marginRight:
                        props.columnGap && !props.mobileView
                          ? props.columnGap / 2 + "px"
                          : "",

                      marginBottom:
                        !props.mobileView ? "0px" : (Object.keys(props.element.columns).length > 1) & (colKeyIndex !== Object.keys(props.element.columns).length - 1)
                          ? props.rowGap + "px"
                          : "0px",

                      backgroundColor: props.element.columnsBG
                        ? typeof props.element.columnsBG[col].bgColor ==
                          "string"
                          ? props.element.columnsBG[col].bgColor
                          : `rgba(
                          ${props.element.columnsBG[col].bgColor.r},
                          ${props.element.columnsBG[col].bgColor.g},
                          ${props.element.columnsBG[col].bgColor.b},
                          ${props.element.columnsBG[col].bgColor.a}
                        )`
                        : "",
                      backgroundImage: props.element.columnsBG
                        ? "url(" + props.element.columnsBG[col].bgImage + ")"
                        : "",
                      backgroundRepeat: props.element.columnsBG
                        ? props.element.columnsBG[col].bgRepeat
                        : "no-repeat",
                      borderStyle: "solid",
                      borderColor:
                        typeof props.element.columnsBG[col].borderColor ==
                          "string" || !props.element.columnsBG[col].borderColor
                          ? "rgba(252, 252, 252, 0)"
                          : `rgba(
                      ${props.element.columnsBG[col].borderColor.r},
                      ${props.element.columnsBG[col].borderColor.g},
                      ${props.element.columnsBG[col].borderColor.b},
                      ${props.element.columnsBG[col].borderColor.a}
                    )`,
                      borderWidth:
                        props.element.columnsBG &&
                        props.element.columnsBG[col].borderWidth
                          ? JSON.parse(props.element.columnsBG[col].borderWidth)
                          : "",
                      backgroundSize: props.element.columnsBG
                        ? props.element.columnsBG[col].bgSize
                        : "",
                    }}
                  >
                    {!props.element.dataModule && (
                      <ColumnBG
                        userID={props.userID}
                        mobileView={props.mobileView}
                        initP={props.initP}
                        element={props.element}
                        sessionID={props.sessionID}
                        ID={props.ID}
                        BGColor={
                          props.element.columnsBG
                            ? props.element.columnsBG[col].bgColor
                            : ""
                        }
                        BGRepeat={
                          props.element.columnsBG
                            ? props.element.columnsBG[col].bgRepeat
                            : ""
                        }
                        BgImage={
                          props.element.columnsBG
                            ? props.element.columnsBG[col].bgImage
                            : ""
                        }
                        gutterSpaceUnit={
                          props.element.columnsBG &&
                          props.element.columnsBG[col].gutterSpaceUnit
                            ? props.element.columnsBG[col].gutterSpaceUnit
                            : "px"
                        }
                        gutterSpace={
                          props.element.columnsBG
                            ? props.element.columnsBG[col].gutterSpace
                            : ""
                        }
                        gutterSpaceLeft={
                          props.element.columnsBG
                            ? props.element.columnsBG[col].gutterSpaceLeft
                            : ""
                        }
                        gutterSpaceRight={
                          props.element.columnsBG
                            ? props.element.columnsBG[col].gutterSpaceRight
                            : ""
                        }
                        gutterSpaceMobile={
                          props.element.columnsBG
                            ? props.element.columnsBG[col].gutterSpaceMobile
                            : ""
                        }
                        gutterSpaceMobileLeft={
                          props.element.columnsBG
                            ? props.element.columnsBG[col].gutterSpaceMobileLeft
                            : ""
                        }
                        gutterSpaceMobileRight={
                          props.element.columnsBG
                            ? props.element.columnsBG[col]
                                .gutterSpaceMobileRight
                            : ""
                        }
                        gutterSpaceTopBottom={
                          props.element.columnsBG
                            ? props.element.columnsBG[col].gutterSpaceTopBottom
                            : ""
                        }
                        gutterSpaceTopBottom_T={
                          props.element.columnsBG
                            ? props.element.columnsBG[col]
                                .gutterSpaceTopBottom_T
                            : ""
                        }
                        gutterSpaceTopBottom_B={
                          props.element.columnsBG
                            ? props.element.columnsBG[col]
                                .gutterSpaceTopBottom_B
                            : ""
                        }
                        gutterSpaceTopBottomMobile={
                          props.element.columnsBG
                            ? props.element.columnsBG[col]
                                .gutterSpaceTopBottomMobile
                            : ""
                        }
                        gutterSpaceTopBottomMobileTop={
                          props.element.columnsBG
                            ? props.element.columnsBG[col]
                                .gutterSpaceTopBottomMobileTop
                            : ""
                        }
                        gutterSpaceTopBottomMobileBottom={
                          props.element.columnsBG
                            ? props.element.columnsBG[col]
                                .gutterSpaceTopBottomMobileBottom
                            : ""
                        }
                        BorderColor={
                          props.element.columnsBG
                            ? props.element.columnsBG[col].borderColor
                            : ""
                        }
                        BorderWidth={
                          props.element.columnsBG &&
                          props.element.columnsBG[col].borderWidth
                            ? props.element.columnsBG[col].borderWidth
                            : ""
                        }
                        ColumnNumber={col}
                        BGSize={
                          props.element.columnsBG
                            ? props.element.columnsBG[col].bgSize
                            : ""
                        }
                      />
                    )}

                    {props.columns[col] && props.columns[col].length === 0 && (
                      <AddToolButton
                        showAddElement={props.showAddElement}
                        tool={UTILS.tool}
                        disableRowTool={props.disableRowTool}
                        ID={props.element.id}
                        block={false}
                        columnNumber={col}
                        mobileView={props.mobileView}
                        forColumn={true}
                        onAddElementorColumnInColumn={
                          props.onAddElementorColumnInColumn
                        }
                      />
                    )}
                    {/* COLUMNS ELEMENTS STARTS */}
                    {props.columns[col].map((colm, colIndex) => {
                      return (
                        <Draggable
                          element={colm}
                          style={
                            dragOverElement &&
                            (dragOverElement.id === colm.id) &
                              (barLocation === "Bottom")
                              ? { borderBottom: "12px solid #C2F5B8" }
                              : dragOverElement &&
                                (dragOverElement.id === colm.id) &
                                  (barLocation === "Top")
                              ? { borderTop: "12px solid #C2F5B8" }
                              : {}
                          }
                          classlist={"item " + (colm.data === "Row" ? "rowMain" : colm.data === "Accordion" ? "accordionMain" : "")}
                          onDrag={(e) => {
                            onDrag(e, colm, props.element, colIndex);
                          }}
                          onDragOver={(e) => {
                            onDragOver(e);
                          }}
                          onDragEnter={(e) => {
                            onDragEnter(e, colm, colIndex, props.element,colKeyIndex);
                          }}
                          onDragEnd={onDragEnd}
                          tool={props.tool}
                          key={colIndex}
                          onAddElementorColumn={props.onAddElementorColumn}
                          ID={colm.id}
                          mobileView={props.mobileView}
                          dataAttr={colm.title}
                        >
                          {colm.data == "IMAGE" ? (
                            <ErrorBoundary>
                              <Image
                                label={colm.label}
                                mobileView={props.mobileView}
                                mobileAlign={
                                  colm.mobileAlign ? colm.mobileAlign : ""
                                }
                                pagesList={props.pagesList}
                                Link={colm.link}
                                element={colm}
                                LinkName={colm.linkname}
                                LinkType={colm.linktype}
                                LinkOpen={colm.linkopen}
                                imageMarginUnit={colm.style.imageMarginUnit}
                                imageWidthUnit={colm.style.imageWidthUnit}
                                marginTop={colm.style.marginTop || 0}
                                marginRight={colm.style.marginRight || 0}
                                marginBottom={colm.style.marginBottom || 0}
                                marginLeft={colm.style.marginLeft || 0}
                                UseSocial={colm.use_social}
                                initP={props.initP}
                                userID={props.userID}
                                key={colIndex}
                                sessionID={props.sessionID}
                                keyID={colIndex}
                                ID={colm.id}
                                srcID={colm.srcID}
                                src={colm.src}
                                style={colm.style}
                                edit={colm.edit}
                                imageClicked={props.imageClicked}
                                addImage={() => props.addImage(colm.id)}
                                clickedImage={props.clickedImage}
                                clickedImageID={props.clickedImageID}
                                toggleUploadPopup={props.toggleUploadPopup}
                                deleteElement={
                                  props.deleteElement
                                }
                                width={colm.style.maxWidth}
                                height={colm.style.height}
                                radius={colm.style.borderRadius}
                                float={colm.style.float}
                                opacity={colm.style.opacity}
                                URL={colm.href}
                                changeImage={() => props.changeImage(colm.id)}
                                cloneElement={ props.cloneElement}
                              />
                            </ErrorBoundary>
                          ) : colm.data == "Line" ? (
                            <ErrorBoundary>
                              <Line
                                label={colm.label}
                                display={colm.style.display}
                                margin={colm.style.margin}
                                key={colIndex}
                                element={colm}
                                lineMarginUnit={colm.style.lineMarginUnit}
                                marginTop={colm.style.marginTop}
                                marginRight={colm.style.marginRight}
                                marginBottom={colm.style.marginBottom}
                                marginLeft={colm.style.marginLeft}
                                borderColor={colm.style.borderColor}
                                borderWidth={colm.style.borderWidth}
                                backgroundColor={colm.style.backgroundColor}
                                style={colm.style}
                                preset={props.preset}
                                width={colm.style.width}
                                ID={colm.id}
                                deleteElement={
                                  props.deleteElement
                                }
                                cloneElement={props.cloneElement}
                              />
                            </ErrorBoundary>
                          ) : colm.data == "FILE" ? (
                            <ErrorBoundary>
                              <File
                                label={colm.label}
                                marginTop={colm.style.marginTop || 0}
                                marginBottom={colm.style.marginBottom || 0}
                                fileMarginUnit={colm.style.fileMarginUnit}
                                fileWidthUnit={colm.style.fileWidthUnit}
                                initP={props.initP}
                                userID={props.userID}
                                element={colm}
                                key={colIndex}
                                sessionID={props.sessionID}
                                keyID={colIndex}
                                ID={colm.id}
                                thumbID={colm.thumbID}
                                thumb={colm.thumb}
                                files={colm.files}
                                deleteElement={
                                  props.deleteElement
                                }
                                cloneElement={ props.cloneElement}
                                style={colm.style}
                                opacity={colm.style.opacity}
                                radius={colm.style.borderRadius}
                                width={colm.style.maxWidth}
                                float={colm.style.float}
                              />
                            </ErrorBoundary>
                          ) : colm.data == "TIMER" ? (
                            <ErrorBoundary>
                                    <TimerElement
                                      element={colm}
                                label={colm.label}
                                ID={colm.id}
                                date={colm.date}
                                key={colIndex}
                                size={colm.size}
                                patternStyle={colm.patternStyle}
                                float={colm.style.float}
                                timerMarginUnit={colm.style.timerMarginUnit}
                                fontFamily={colm.style.fontFamily}
                                marginTop={colm.style.marginTop}
                                marginRight={colm.style.marginRight}
                                marginBottom={colm.style.marginBottom}
                                marginLeft={colm.style.marginLeft}
                                margin={colm.style.margin}
                                deleteElement={
                                  props.deleteElement
                                }
                                cloneElement={ props.cloneElement}
                              />
                            </ErrorBoundary>
                          ) : colm.data == "TABLE" ? (
                            <ErrorBoundary>
                              <TABLEEditor
                                label={colm.label}
                                mobileView={props.mobileView}
                                element={colm}
                                selectedFont={props.selectedFont}
                                preset={props.preset}
                                pagesList={props.pagesList}
                                ID={colm.id}
                                edit={colm.edit}
                                content={colm.content}
                                fontFamily={colm.style && colm.style.fontFamily}
                                mobileContent={colm.mobileStyle.content}
                                desktopContent={colm.desktopStyle.content}
                                isMirrored={colm.isMirrored}
                                key={colIndex}
                                deleteElement={
                                  props.deleteElement
                                }
                                cloneElement={props.cloneElement}
                                style={colm.style}
                                tableMobileUnit={colm.tableMobileUnit}
                                tableDesktopUnit={colm.tableDesktopUnit}
                              />
                            </ErrorBoundary>
                          ) : colm.data == "HTML" ? (
                            <ErrorBoundary>
                              <HTMLEditor
                                mobileView={props.mobileView}
                                element={colm}
                                pagesList={props.pagesList}
                                ID={colm.id}
                                edit={colm.edit}
                                content={colm.content}
                                fontFamily={colm.style && colm.style.fontFamily}
                                key={colIndex}
                                deleteElement={
                                  props.deleteElement
                                }
                                          selectedFont={props.selectedFont}
                                cloneElement={ props.cloneElement}
                                style={colm.style}
                              />
                            </ErrorBoundary>
                          ) : colm.data == "BUTTON" ? (
                            <ErrorBoundary>
                              <BUTTON
                                label={colm.label}
                                mobileView={props.mobileView}
                                pagesList={props.pagesList}
                                Link={colm.link}
                                LinkName={colm.linkname}
                                LinkType={colm.linktype}
                                element={colm}
                                LinkOpen={colm.linkopen}
                                fullWidth={colm.style.width || "auto"}
                                UseSocial={colm.use_social}
                                deleteElement={
                                  props.deleteElement
                                }
                                ID={colm.id}
                                style={colm.style}
                                mobileAlignment={colm.mobileAlignment || "none"}
                                // IDELE={id}
                                fontName={colm.style.fontFamily}
                                fontSize={colm.style.fontSize}
                                key={colIndex}
                                borderRadius={colm.style.borderRadius}
                                borderWidthVal={colm.style.borderWidth}
                                borderWidth={colm.style.borderWidth}
                                paddingTop={colm.style.paddingTop}
                                paddingRight={colm.style.paddingRight}
                                paddingBottom={colm.style.paddingBottom}
                                paddingLeft={colm.style.paddingLeft}
                                btnPaddingUnit={colm.style.btnPaddingUnit}
                                btnMarginUnit={colm.style.btnMarginUnit}
                                marginTop={colm.style.marginTop}
                                marginRight={colm.style.marginRight}
                                marginBottom={colm.style.marginBottom}
                                marginLeft={colm.style.marginLeft}
                                floatVal={colm.style.float}
                                buttonURL={colm.buttonURL}
                                content={colm.content}
                                keyID={colm.id}
                                editVal={colm.edit}
                                normalTextColor={
                                  colm.normalBtn.txtColor.rgb || {
                                    r: 255,
                                    g: 255,
                                    b: 255,
                                    a: 1,
                                  }
                                }
                                normalBtnBg={
                                  colm.normalBtn.btnBG.rgb || {
                                    r: 12,
                                    g: 50,
                                    b: 84,
                                    a: 1,
                                  }
                                }
                                normalBtnBorder={
                                  colm.normalBtn.btnBorder.rgb || {
                                    r: 12,
                                    g: 50,
                                    b: 84,
                                    a: 1,
                                  }
                                }
                                hoverBtnTextColor={
                                  colm.hoverBtn.txtColor.rgb || {
                                    r: 255,
                                    g: 255,
                                    b: 255,
                                    a: 1,
                                  }
                                }
                                hoverBtnBgColor={
                                  colm.hoverBtn.btnBg.rgb || {
                                    r: 0,
                                    g: 98,
                                    b: 204,
                                    a: 1,
                                  }
                                }
                                hoverBorder={
                                  colm.hoverBtn.btnBorder.rgb || {
                                    r: 12,
                                    g: 50,
                                    b: 84,
                                    a: 1,
                                  }
                                }
                                cloneElement={ props.cloneElement}
                                fontWeight={colm.style.fontWeight || "normal"}
                              />
                            </ErrorBoundary>
                          ) : colm.data == "FORM" ? (
                            <ErrorBoundary>
                              <Form
                                label={colm.label}
                                FormObj={colm}
                                formArray={colm.fields}
                                key={colIndex}
                                ID={colm.id}
                                width={colm.style.width}
                                borderWidth={colm.style.borderWidth}
                                borderStyle={colm.style.borderStyle}
                                borderRadius={colm.style.borderRadius}
                                borderColor={colm.style.borderColor}
                                formMarginUnit={colm.style.formMarginUnit}
                                fontFamily={colm.style.fontFamily}
                                marginTop={colm.style.marginTop || 0}
                                marginRight={colm.style.marginRight || 0}
                                marginBottom={colm.style.marginBottom || 0}
                                marginLeft={colm.style.marginLeft || 0}
                                backgroundColor={colm.style.backgroundColor}
                                color={colm.style.color}
                                              email={colm.email}
                                              element={colm}
                                deleteElement={
                                  props.deleteElement
                                }
                                cloneElement={ props.cloneElement}
                              />
                            </ErrorBoundary>
                          ) : colm.data == "TEXT" ? (
                            <ErrorBoundary>
                              <Text
                                selectedFont={props.selectedFont}
                                preset={props.preset}
                                mobileView={props.mobileView}
                                mobileAlign={
                                  colm.mobileAlign ? colm.mobileAlign : ""
                                }
                                desktopAlign={
                                  colm.desktopAlign ? colm.desktopAlign : ""
                                }
                                label={colm.label}
                                pagesList={props.pagesList}
                                keyID={colm.id}
                                key={colIndex}
                                ID={colm.id}
                                itemIndex={colIndex}
                                element={colm}
                                editVal={colm.edit}
                                deleteElement={
                                  props.deleteElement
                                }
                                editOption={colm.edit}
                                lineHeightVal={colm.style.lineHeight}
                                maxWidth={colm.maxWidth}
                                // marginLeft={colm.marginLeft}
                                textContent={colm.text}
                                cloneElement={props.cloneElement}
                                fontSize={colm.style.fontSize}
                                fontName={colm.style.fontFamily}
                                marginTop={colm.style.marginTop || 0}
                                marginRight={colm.style.marginRight || 0}
                                marginBottom={colm.style.marginBottom || 0}
                              />
                            </ErrorBoundary>
                          ) : colm.data == "Row" ? (
                            <Fragment>
                              <NestedColumn
                                preset={props.preset}
                                tool={props.tool}
                                pagesList={props.pagesList}
                                showAddElement={props.showAddElement}
                                label={colm.label}
                                mobileView={props.mobileView}
                                dropContainerWidth={dropContainerWidth}
                                gridGuideColumns={props.gridGuideColumns}
                                gridGuideGutterSpace={
                                  props.gridGuideGutterSpace
                                }
                                ID={colm.id}
                                onAddElementorColumn={
                                  props.onAddElementorColumn
                                }
                                onAddElementorColumnInColumn={
                                  props.onAddElementorColumnInColumn
                                }
                                resizeID={props.resizeID}
                                deleteElement={props.deleteElement}
                                cloneElement={props.cloneElement}
                                layout={props.layout}
                                deskWidth={colm.deskWidth}
                                element={colm}
                                index={colIndex}
                                addedIndex={props.addedIndex}
                                getSizes={getSizes}
                                initP={props.initP}
                                userID={props.userID}
                                                  sessionID={props.sessionID}
                                                  selectedFont={props.selectedFont}
                                bgRepeat={
                                  colm.rowStyle && colm.rowStyle.bgRepeat
                                    ? colm.rowStyle.bgRepeat
                                    : "no-repeat"
                                }
                                bgSize={
                                  colm.rowStyle && colm.rowStyle.bgSize
                                    ? colm.rowStyle.bgSize
                                    : "cover"
                                }
                                rowStyle={colm.rowStyle ? colm.rowStyle : null}
                                rowBg={
                                  colm.rowStyle && colm.rowStyle.rowBg
                                    ? colm.rowStyle.rowBg
                                    : undefined
                                }
                                rowBgColor={
                                  colm.rowStyle && colm.rowStyle.rowBgColor
                                    ? colm.rowStyle.rowBgColor
                                    : "transparent"
                                }
                                rowBorderColor={
                                  colm.rowStyle && colm.rowStyle.rowBorderColor
                                    ? colm.rowStyle.rowBorderColor
                                    : "#000000"
                                }
                                rowCroppedBg={
                                  colm.rowStyle && colm.rowStyle.croppedBg
                                    ? colm.rowStyle.croppedBg
                                    : undefined
                                }
                                rowBgWidth={
                                  colm.rowStyle && colm.rowStyle.bgWidth
                                    ? colm.rowStyle.bgWidth
                                    : undefined
                                }
                                borderWidth={
                                  colm.rowStyle && colm.rowStyle.borderWidth
                                    ? colm.rowStyle.borderWidth
                                    : "0"
                                }
                                gutterSpaceBtwnCol={
                                  colm.rowStyle &&
                                  colm.rowStyle.gutterSpaceBtwnCol
                                    ? colm.rowStyle.gutterSpaceBtwnCol
                                    : props.gutterSpaceBtwnCol
                                    ? props.gutterSpaceBtwnCol
                                    : "0"
                                }
                                gutterSpaceBtwnColMobile={
                                  colm.rowStyle &&
                                  colm.rowStyle.gutterSpaceBtwnColMobile
                                    ? colm.rowStyle.gutterSpaceBtwnColMobile
                                    : props.gutterSpaceBtwnColMobile
                                    ? props.gutterSpaceBtwnColMobile
                                    : "0"
                                }
                                rowOpacity={
                                  colm.rowStyle && colm.rowStyle.opacity
                                    ? colm.rowStyle.opacity
                                    : "1.0"
                                }
                                columnGap={props.columnGap}
                                rowGap={props.rowGap}
                                canvasRowsPaddingUnit={
                                  props.canvasRowsPaddingUnit
                                }
                                canvasRowsPadding={props.canvasRowsPadding}
                                canvasRowsPaddingMobile={
                                  props.canvasRowsPaddingMobile
                                }
                                columns={colm.columns}
                                addRemoveColumn={props.addRemoveColumn}
                                removeColumn={props.removeColumn}
                                itemID={props.itemID}
                                addImage={props.addImage}
                                changeImage={props.changeImage}
                                clickedImage={props.clickedImage}
                                clickedImageID={props.clickedImageID}
                                toggleUploadPopup={props.toggleUploadPopup}
                                Layout={props.layout}
                                onChangeHandler={props.onChangeHandler}
                                modalUpload={props.modalUpload}
                                selectedFile={props.selectedFile}
                                loaded={props.loaded}
                                videoClicked={props.videoClicked}
                                videoDataID={props.videoDataID}
                                addVideo={props.addVideo}
                                videoOption={props.videoOption}
                              />
                            </Fragment>
                          ) : colm.data == "VIDEO" ? (
                            <ErrorBoundary>
                              <VideoElement
                                marginTop={colm.style.marginTop || 0}
                                marginBottom={colm.style.marginBottom || 0}
                                videoMarginUnit={colm.style.videoMarginUnit}
                                label={colm.label}
                                videoWidthUnit={colm.style.videoWidthUnit}
                                element={colm}
                                userID={props.userID}
                                vimeoID={colm.vimeoID || null}
                                youtubeID={colm.youtubeID || null}
                                vimeoTHUMB={colm.vimeoTHUMB || null}
                                youtubeTHUMB={colm.youtubeTHUMB || null}
                                video_url={colm.video_url || null}
                                videoURL_ADDRESS={
                                  colm.vimeoTHUMB
                                    ? colm.vimeoTHUMB
                                    : colm.youtubeTHUMB
                                    ? colm.youtubeTHUMB
                                    : ""
                                }
                                initP={props.initP}
                                sessionID={props.sessionID}
                                showChaptersToggle={colm.showChaptersToggle}
                                if_src={colm.src}
                                key={colIndex}
                                ID={colm.id}
                                addVideo={() =>
                                  props.addVideo(colm.id, colm.videoID)
                                }
                                videoOption={() => {
                                  props.videoOption(colm.id);
                                }}
  
                                VideoWidth={colm.style.maxWidth}
                                srcID={colm.srcID}
                                editEnable={colm.edit}
                                modalUpload={props.modalUpload}
                                selectedFile={props.selectedFile}
                                toggleUploadPopup={props.toggleUploadPopup}
                                onChangeHandler={props.onChangeHandler}
                                loaded={props.loaded}
                                videoClicked={props.videoClicked}
                                videoDataID={props.videoDataID}
                                autoplay={colm.autoplay}
                                modal={colm.modal}
                                chapters={colm.chapters}
                                control={colm.control}
                                layout={props.layout}
                                cloneElement={ props.cloneElement}
                                deleteElement={props.deleteElement}
                              />
                            </ErrorBoundary>
                          ) : colm.data == "Accordion" ? (
                            <NestedAccordion
                              selectedFont={props.selectedFont}
                              disableRowTool={true}
                              accordionNestType="nestedAccordionColumn"
                              preset={props.preset}
                              showAddElement={props.showAddElement}
                              tool={props.tool}
                              preventDrop={props.preventDrop}
                              pagesList={props.pagesList}
                              mobileView={props.mobileView}
                              ID={colm.id}
                              dropContainerWidth={dropContainerWidth}
                              gridGuideColumns={props.gridGuideColumns}
                              gridGuideGutterSpace={props.gridGuideGutterSpace}
                              onAddElementorColumn={props.onAddElementorColumn}
                              onAddElementorColumnInColumn={
                                props.onAddElementorColumnInColumn
                              }
                              deleteElement={
                                props.deleteElement
                              }
                              cloneElement={
                                props.cloneElement
                              }
                           
                              deskWidth={colm.deskWidth}
                              index={colIndex}
                              label={colm.label}
                              element={colm}
                              resizeID={props.resizeID}
                              addedIndex={props.addedIndex}
                              getSizes={getSizes}
                              initP={props.initP}
                              userID={props.userID}
                              sessionID={props.sessionID}
                              bgRepeat={
                                colm.rowStyle && colm.rowStyle.bgRepeat
                                  ? colm.rowStyle.bgRepeat
                                  : "no-repeat"
                              }
                              bgSize={
                                colm.rowStyle && colm.rowStyle.bgSize
                                  ? colm.rowStyle.bgSize
                                  : "cover"
                              }
                              rowStyle={colm.rowStyle ? colm.rowStyle : null}
                              rowBg={
                                colm.rowStyle && colm.rowStyle.rowBg
                                  ? colm.rowStyle.rowBg
                                  : undefined
                              }
                              rowBgColor={
                                colm.rowStyle && colm.rowStyle.rowBgColor
                                  ? colm.rowStyle.rowBgColor
                                  : "transparent"
                              }
                              rowBorderColor={
                                colm.rowStyle && colm.rowStyle.rowBorderColor
                                  ? colm.rowStyle.rowBorderColor
                                  : "#000000"
                              }
                              borderWidth={
                                colm.rowStyle && colm.rowStyle.borderWidth
                                  ? colm.rowStyle.borderWidth
                                  : "0"
                              }
                              rowCroppedBg={
                                colm.rowStyle &&
                                colm.rowStyle.croppedBg !== null
                                  ? colm.rowStyle.croppedBg
                                  : undefined
                              }
                              rowBgWidth={
                                colm.rowStyle && colm.rowStyle.bgWidth
                                  ? colm.rowStyle.bgWidth
                                  : undefined
                              }
                              rowOpacity={
                                colm.rowStyle && colm.rowStyle.opacity
                                  ? colm.rowStyle.opacity
                                  : "1.0"
                              }
                              columnGap={props.columnGap}
                              rowGap={props.rowGap}
                              canvasRowsPaddingUnit={
                                props.canvasRowsPaddingUnit
                              }
                              canvasRowsPadding={props.canvasRowsPadding}
                              canvasRowsPaddingMobile={
                                props.canvasRowsPaddingMobile
                              }
                              columns={colm.columns}
                              addRemoveColumn={props.addRemoveColumn}
                              removeColumn={props.removeColumn}
                              itemID={props.itemID}
                              toggleUploadPopup={props.toggleUploadPopup}
                              onChangeHandler={props.onChangeHandler}
                              modalUpload={props.modalUpload}
                              selectedFile={props.selectedFile}
                              loaded={props.loaded}
                              videoClicked={props.videoClicked}
                              videoDataID={props.videoDataID}
                              layout={props.layout}
                              addVideo={props.addVideo}
                              videoOption={props.videoOption}
                            />
                          ) : null}
                        </Draggable>
                      );
                    })}
                    {/* COLUMNS ELEMENTS ENDS */}
                  </div>
                );
              })}
            </Fragment>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutList: state.present.layoutList,
    layoutTitle: state.present.layoutTitle,
    columnGap: state.present.canvasStyle.columnGap,
    rowGap: state.present.canvasStyle.rowGap,
    canvasRowsPaddingUnit: state.present.canvasStyle.canvasRowsPaddingUnit,
    enableWidthForRow: state.present.enableWidthForRow,
    canvasRowsPadding: state.present.canvasStyle.canvasRowsPadding,
    containerWidth: state.present.containerWidth,
    canvasRowsPaddingMobile: state.present.canvasStyle.canvasRowsPaddingMobile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(RowColumns);
